import { Api } from '../AApi'

export const API_MAPSHARE_LEGEND = new Api(
  {
    url: 'map-share-legends',
    isConvertFormData: false,
  },
  {
    list: {
      request(map_share_id) {
        return this.sdk.get(`${this.url}`, {
          params: { map_share_id }
        }).then(res => res.data)
      }
    },
    update: {
      request(id, data, option = {}) {
        // Handle FormData correctly for Laravel (needs POST + _method: PUT)
        if (data instanceof FormData) {
          data.append('_method', 'PUT')
          return this.sdk.post(`${this.url}/${id}`, data, {
            headers: { 'Content-Type': 'multipart/form-data' },
            ...option
          }).then(res => res.data.data || res.data)
        }
        return this.sdk.put(`${this.url}/${id}`, data, option).then(res => res.data.data || res.data)
      }
    },
    delete: {
      request(id) {
        return this.sdk.delete(`${this.url}/${id}`).then(res => res.data)
      }
    }
  }
)
